import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { AfterContentInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Analyse } from 'src/app/domain/Analyse/analyse';
import { AnalyseStatut } from 'src/app/domain/Analyse/enum/analyse-statut';
import { Taxon } from 'src/app/domain/Analyse/taxon';
import { User } from 'src/app/domain/planning/user';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { SpeedDialFabModel } from 'src/app/models/speed-dial-fab.model';
import { AnalyseService } from 'src/app/services/analyse-service';
import { TaxonService } from 'src/app/services/taxon-service';
import { UserService } from 'src/app/services/user-service';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { TaxonCyanoBoxComponent } from 'src/app/tools/ui/taxon-cyano-box/taxon-cyano-box.component';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { ConfirmBoxModel } from 'src/app/tools/ui/confirm-box/confirm-box.model';

@Component({
    selector: 'app-analyse-cyano',
    templateUrl: './analyse-cyano.component.html',
    styleUrls: ['./analyse-cyano.component.scss']
})
export class AnalyseCyanoComponent implements OnInit, AfterContentInit {

    AnalyseStatut = AnalyseStatut;
    @ViewChild('analyste') analyste: ElementRef<HTMLInputElement>;
    public AllUserList: User[] = [];
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    addOnBlur = true;
    selectable = true;

    public model: Analyse = new Analyse();
    public FabOptions: SpeedDialFabModel[] =
        [
            {
                Id: 0,
                Text: undefined,
                Icon: 'save',
            },
            {
                Id: 1,
                Text: undefined,
                Icon: 'done',
            },
            {
                Id: 2,
                Text: undefined,
                Icon: 'add',
            },
        ];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private analysisService: AnalyseService,
        private userService: UserService,
        private taxonService: TaxonService
    ) { }

    ngOnInit(): void {

    }

    ngAfterContentInit(): void {
        if (!this.route.snapshot.params.analyseCode) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }
        this.getAvailableUserList();
        this.getAnalyse(this.route.snapshot.params.analyseCode);
    }

    openCyanoTaxonDialog(taxon?: Taxon) {

        const dialogRef = this.dialog.open(TaxonCyanoBoxComponent, {
            width: '600px',
            data: {
                taxon: taxon,
                alreadyPicked: this.model.TaxonList
            }
        });
        dialogRef.afterClosed().subscribe((result: Taxon) => {
            if (result) {
                this.updateTaxonForCyano(result)
            }
        });
    }

    addColonie(taxon: Taxon) {
        if (taxon.Colonie >= 100)
            NotificationManager.handleWarning('Attention vous avez atteint 100 colonies', this.snackBar)
        
        // Localy update
        taxon.Colonie++

        // Add/Count by the server side
        let newCount = Object.assign({}, taxon)
        newCount.Colonie = 1
        this.updateTaxonForCyano(newCount)
    }

    // #region Analyser - analyste
    removeAnalyser(user: User): void {
        const index = this.model.AnalyserList.indexOf(user);

        if (index >= 0) {
            this.model.AnalyserList.splice(index, 1);
        }
    }

    selectedAnalyser(event: MatAutocompleteSelectedEvent) {
        this.model.AnalyserList.push(this.AllUserList.find(u => u.Fullname === event.option.viewValue));
        this.analyste.nativeElement.value = '';
    }
    // #endregion

    // #region Services
    getAnalyse(code: string) {
        this.analysisService.getAnalyseByCode(code).subscribe(x => {
            if (x) {
                this.model = x;
            }
        })
    }

    getAvailableUserList() {
        this.userService.getAll().subscribe(x => this.AllUserList = x);
    }

    save() {
        this.analysisService.update(this.model).subscribe(x => {
            NotificationManager.handleSuccess(`Analyse mise à jour`, this.snackBar);
        });
    }

    toggleValidation() {
        this.analysisService.finishAnalyse(this.model.Code).subscribe(x => {
            if (x) {
                if (this.model.Status === AnalyseStatut.Done) {
                    NotificationManager.handleSuccess(`En cours d'analyse`, this.snackBar);
                    this.model.Status = AnalyseStatut.InProgress;
                } else {
                    NotificationManager.handleSuccess(`Analyse terminée`, this.snackBar);
                    this.model.Status = AnalyseStatut.Done;
                }
            }
        });
    }

    deleteTaxon(t: Taxon) {
        const m: ConfirmBoxModel = new ConfirmBoxModel();
        m.QuestionTitle = 'Etes-vous sûr de vouloir supprimer le taxon ?';
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: m,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: ConfirmBoxModel) => {
            if (!result)
                return;

            this.taxonService.deleteTaxonByCode(t.Code).subscribe(x => {
                if (x) {
                    NotificationManager.handleSuccess(`Taxon retiré`, this.snackBar);
                    this.getAnalyse(this.route.snapshot.params.analyseCode);
                }
            })
        });
    }

    undoLastCount(t: Taxon) {
        this.taxonService.undoLastTaxonCountForCyano(t).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess(`Comptage annulé`, this.snackBar);
                this.getAnalyse(this.route.snapshot.params.analyseCode);
            }
        })
    }

    updateTaxonForCyano(result: Taxon) {

        this.taxonService.updateTaxonForCyano(this.model.Code, result).subscribe(x => {
                this.getAnalyse(this.route.snapshot.params.analyseCode);
        })
    }

    // #endregion

    dispatch(event: SpeedDialFabModel) {

        switch (event.Id) {
            case 0:
                this.save();
                break;
            case 1:
                this.toggleValidation();
                break;
            case 2:
                this.openCyanoTaxonDialog();
                break;
        }
    }
}
